/* eslint-disable camelcase */
/* eslint-disable dot-notation */
import ApiService from './ApiService'

/**
 * AuthService Class.
 *
 * @class
 */
export default class AuthService {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * AuthService constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_AUTH_API)
    }

    /**
     * Register a new user.
     *
     * @param {Object} settings
     * @param {Object} user
     * @param {Object} device
     *
     * @returns {Promise}
     */
    register({ api_key, company_uuid, cc, lang }, user, device) {
        const params = {
            email: user.email,
            password: user.password,
            password_confirmation: user.confirmation,
            opt_in_marketing: user.marketingOptIn,
            device_type: device.type,
            device_identifier: device.identifier,
            device_name: device.name,
        }

        if (user.phoneNumber !== null) {
            params.phone_number = user.phoneNumber
        }

        if (user.zipCode !== null) {
            params.zip_code = user.zipCode
        }

        if (user.gender !== null) {
            params.gender = user.gender
        }

        return this.apiService
            .setApiKey(api_key)
            .setAcceptLanguage(`${lang}-${cc}`)
            .post(`/${company_uuid}/register`, params)
    }

    /**
     * Login user.
     *
     * @param {Object} settings
     * @param {Object} user
     * @param {Object} device
     *
     * @returns {Promise}
     */
    login({ api_key, company_uuid, cc, lang }, { username, password }, device) {
        return this.apiService
            .setApiKey(api_key)
            .setAcceptLanguage(`${lang}-${cc}`)
            .post(`/${company_uuid}/login`, {
                username,
                password,
                device_type: device.type,
                device_identifier: device.identifier,
                device_name: device.name,
            })
    }

    /**
     * Request reset password email.
     *
     * @param {Object} settings
     * @param {Object} user
     *
     * @returns {Promise}
     */
    getResetPasswordLink({ api_key, company_uuid, cc, lang }, { email }) {
        return this.apiService
            .setApiKey(api_key)
            .setAcceptLanguage(`${lang}-${cc}`)
            .post(`/${company_uuid}/password/email`, {
                email,
            })
    }

    resetPassword({ api_key, company_uuid, cc, lang }, { token, email, password, confirmation }) {
        return this.apiService
            .setApiKey(api_key)
            .setAcceptLanguage(`${lang}-${cc}`)
            .post(`/${company_uuid}/password/reset`, {
                token,
                email,
                password,
                password_confirmation: confirmation,
            })
    }

    async checkSession({ company_uuid, cc, lang }, token, device) {
        try {
            await this.apiService
                .setAccessToken(token)
                .setAcceptLanguage(`${lang}-${cc}`)
                .post(`/${company_uuid}/check-session`, {
                    device_type: device.type,
                    device_identifier: device.identifier,
                })

            return true
        } catch (error) {
            return false
        }
    }
}
